/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, themeStyleHelper, disable } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// BUTTON STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library))
export default theme => ({
	button: {
		cursor: 'pointer',
		display: 'inline-flex',
		outline: 'none',
		position: 'relative',
		userSelect: 'none',
		alignItems: 'center',
		verticalAlign: 'middle',
		justifyContent: 'center',
		textTransform: 'none',
		transition: theme.animation.general('all'),
		padding: replacePXinStringWithEM('0px 10px'),
		border: '0',
		borderRadius: pxToEm(5),
		width: pxToEm(213),
		height: pxToEm(48),
		fontSize: pxToEm(16),
		fontWeight: '600',
		whiteSpace: 'nowrap',
		// icon
		'& .icon': {
			'& i': {
				fontSize: '150%',
				marginRight: pxToEm(7),
			}
		},
		// text
		'& .text': {
			
		},
		// loader
		'& .loader': {
            display: 'none',
            fontSize: '38%',
            marginRight: pxToEm(15)
            // marginTop: pxToEm(-20)
        },

		// ----- names ----- //
		'&.name-signingoogle': {
			background: '#DD4B39',
			color: '#fff'
		},

		// ----- variant ----- //
		'&.variant-primary': {
			background: theme.color.primary.medium.swatch,
			color: theme.color.primary.medium.contrast,
			'& .loader div': { borderTopColor: theme.color.primary.medium.contrast }
		},
		'&.variant-secondary': {
			background: theme.color.primary.light.swatch,
			color: theme.color.primary.light.contrast,
			'& .loader div': { borderTopColor: theme.color.primary.light.contrast }
		},
		'&.variant-normal': {
			background: theme.color.supporting.light.swatch,
			color: theme.color.supporting.light.contrast,
			'& .loader div': { borderTopColor: theme.color.supporting.light.contrast }
		},
		'&.variant-system': {
			background: theme.color.supporting.light.swatch,
			color: theme.color.primary.medium.swatch,
			border: '0',
			'& .loader div': { borderTopColor: theme.color.primary.medium.swatch }
		},
		'&.variant-disabled': {
			cursor: 'default',
			pointerEvents: 'none',
			background: theme.color.neutral.light.swatch,
			color: theme.color.neutral.medium.swatch
		},
		'&.variant-action': {
			background: theme.color.secondary.medium.swatch,
			color: theme.color.secondary.medium.contrast,
			'& .loader div': { borderTopColor: theme.color.secondary.medium.contrast }
		},
		'&.variant-delete': {
			background: theme.color.attention.medium.swatch,
			color: theme.color.attention.medium.contrast,
			'& .loader div': { borderTopColor: theme.color.attention.medium.contrast }
		},
		'&.variant-combination': {
			// background: linear-gradient(to right, #7ed321 0%,#1494f4 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			background: `linear-gradient(to bottom, ${theme.color.secondary.medium.swatch} 0%, ${theme.color.primary.medium.swatch} 100%)`, /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
			color: theme.color.secondary.medium.contrast,
			'& .loader div': { borderTopColor: theme.color.secondary.medium.contrast }
		},
		'&.variant-control': {
			background: '#F3F6F8',
			borderRadius: pxToEm(3),
			color: '#1494F4',
			padding: replacePXinStringWithEM('5px 20px'),
			width: 'auto',
			height: 'auto',
			extend: theme.typography.size.xsmall,
			border: 'none',
			'& .loader div': { borderTopColor: `#1494F4` }
		},

		// ----- colors ----- //
		// generates classes for every color in the theme ".color-(uniqueColor)"
		extend: themeStyleHelper(theme, 'color', (theme, uniqueColor) => {
			return {
				background: theme.color[uniqueColor].medium.swatch,
				color: theme.color[uniqueColor].medium.contrast,
				'& .loader div': { borderTopColor: theme.color[uniqueColor].medium.contrast }
			}
		}),

		// +++++ states +++++ //
		'&:hover': {
			filter: 'brightness(93%)'
		},
		'&.iconRight-true': {
			'& .text': { order: '-1' },
			'& .icon': { '& i': { marginRight: '0', marginLeft: pxToEm(7) } }
		},
        '&:disabled': {
            extend: disable
        },
        '&.processing-true': {
        	cursor: 'default',
			pointerEvents: 'none',
            '& .loader': {
                display: 'inline-block'
            }
        }
	}
});